export const BUSINESS_OPTIONS = [
  { value: false, text: "No" },
  { value: true, text: "Yes" },
];

export const STATUS_OPTIONS = {
  ACTIVE: "Active",
  ACTIVE_BEING_REPLACED: "Active - Being Replaced",
  ACTIVE_REPLACED_WITH_1035: "Active - Being Replaced with 1035",
  ACTIVE_ALTERING_PREMIUM: "Active - Altering Premium",
  PENDING: "Pending",
  SOLD: "Sold",
  LAPSED: "Lapsed",
};

export type StatusOption = (typeof STATUS_OPTIONS)[keyof typeof STATUS_OPTIONS];

interface ExistingCoverage {
  business_insurance?: boolean | null;
  carrier_id?: number | null;
  face_amount?: number | null;
  id?: number | null;
  insured_id?: number | null;
  monthly_benefit?: number | null;
  policy_date?: string | null;
  policy_number?: string | null;
  premium?: number | null;
  replacement_reason?: string | null;
  status?: StatusOption | null;
}

interface RawExistingCoverage {
  business_insurance?: boolean | null;
  carrier?: {
    id?: number;
  };
  face_amount?: number | null;
  id?: number | null;
  insured_id?: number | null;
  monthly_benefit?: number | null;
  policy_date?: string | null;
  policy_number?: string | null;
  premium?: number | null;
  replacement_reason?: string | null;
  status?: StatusOption | null;
}

const numOrNull = (v: number | null | undefined) => (v || v === 0 ? v : null);
const boolOrNull = (v: boolean | null | undefined) =>
  typeof v === "boolean" ? v : null;
const valOrNull = <T>(v?: T | null): T | null => v || null;

export function ExistingCoverageMapper(
  model: Partial<RawExistingCoverage> = {}
): ExistingCoverage {
  return {
    business_insurance: boolOrNull(model?.business_insurance),
    carrier_id: numOrNull(model?.carrier?.id),
    face_amount: numOrNull(model?.face_amount),
    id: numOrNull(model?.id),
    insured_id: numOrNull(model?.insured_id),
    monthly_benefit: numOrNull(model?.monthly_benefit),
    policy_date: valOrNull<string>(model?.policy_date),
    policy_number: valOrNull<string>(model?.policy_number),
    premium: numOrNull(model?.premium),
    replacement_reason: valOrNull<string>(model?.replacement_reason),
    status: valOrNull<StatusOption>(model?.status),
  };
}
